<template>
  <KPage>
    <!--  -->
    <FilterBar />

    <!--  -->
    <v-card outlined class="overflow-hidden">
      <v-row class="ma-0">
        <v-col cols="12" xs="12" class="pa-0">
          <v-list class="pa-0 bordered">
            <v-list-item v-for="(item, key) in financial_gateways" :key="key">
              <v-list-item-avatar>
                <v-icon>mdi-bank</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="item.name"></v-list-item-title>
                <v-list-item-subtitle>
                  <KChip yellow>{{item.slug}}</KChip>
                  <KChip v-if="item.is_active" blue>Ativo</KChip>
                  <KChip v-else>Inativo</KChip>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <!-- </v-card-text> -->
          </v-list>
        </v-col>
      </v-row>
    </v-card>

    <!--  -->
  </KPage>
</template>

<script>
import KPage from "@/components/KPage";
import KChip from "@/components/KChip";

import FilterBar from "./FilterBar";

export default {
  components: {
    KPage,
    KChip,

    FilterBar
  },

  data() {
    return {
      //
      loading: false,

      //
      dialog: {
        visible: true
      }
    };
  },

  computed: {
    /**
     * Alimenta os partidos de forma reativa
     */
    financial_gateways() {
      return this.$store.getters["financial_gateways/all"];
    }
  },

  //
  methods: {
    /**
     * Carrega os partidos caso ainda não estejam
     */
    async load() {
      try {
        this.loading = true;
        this.$loading.show();
        await this.$store.dispatch("financial_gateways/all");
        this.loading = false;
        this.$loading.hide();
      } catch (error) {
        this.$message.serverError(error);
        this.loading = false;
        this.$loading.hide();
      }
    }
  },

  mounted() {
    this.load();
  }
};
</script>
